import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { LoggerService } from './logger.service';
import { PosterService } from './poster.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  logs: any = [];

  constructor(
    private logger: LoggerService,
    private poster: PosterService,
    private storage: Storage
  ) {}

  updateLog(log) {
    return this.storage
      .get('signupLogs')
      .then((res) => {
        this.logs = res ? res : [];
        this.logs.push(log);
        return this.storage.set('signupLogs', this.logs);
      })
      .then(() => {
        this.logger.info('Signup', MSRemoteLoggerCategory.AUTH_SERVICE, {
          msg: this.logs
        })
      })
      .catch((err) => {
        this.logger.log('Error in updating signup logs', MSRemoteLoggerCategory.AUTH_SERVICE, err);
      });
  }

  getSignupEmail() {
    return this.storage.get('signupEmail');
  }

  setSignupEmail(email) {
    return this.storage.set('signupEmail', email);
  }
}
